import { render, staticRenderFns } from "./CountCard.vue?vue&type=template&id=2384df63&scoped=true"
import script from "./CountCard.vue?vue&type=script&lang=js"
export * from "./CountCard.vue?vue&type=script&lang=js"
import style0 from "./CountCard.vue?vue&type=style&index=0&id=2384df63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384df63",
  null
  
)

export default component.exports